import type { BindingType, FieldBinding } from '@doer/frontend-components/creativity-editor';
import type { RoutedFormData } from '../../../../types/templates';
import { resolveBindingTargets } from '../binders';

export type Patch = { bindingType: BindingType; value: unknown };

// Last binding wins on pieceId collisions.
export function buildPatches(
  bindings: FieldBinding[],
  formData: RoutedFormData,
  defaults: RoutedFormData,
  resolutionId?: string
): Map<string, Patch> {
  const patches = new Map<string, Patch>();
  for (const binding of bindings) {
    for (const target of resolveBindingTargets(binding, formData, defaults, resolutionId)) {
      patches.set(target.pieceId, { bindingType: target.bindingType, value: target.value });
    }
  }
  return patches;
}
